import type { CatalogueConfig } from '../catalogue/catalogue.types';
import type { Bullet } from './models/bullet.model';
import { BulletStoreService } from './services/bullet-store.service';

export const BULLET_CATALOGUE: CatalogueConfig<Bullet> = {
  label: 'Bullet',
  plural: 'Bullets',
  routeBase: '/bullets',
  storeToken: BulletStoreService,
  placeholderIcon: '@tui.circle-dot',
  badges: (b) => [b.calibre ?? '', b.weight_grains == null ? '' : `${b.weight_grains} gr`],
};
